import theme from '../../../lib/theme';

import { PageBodyProps } from './PageBody';

const { scale, colors, font, layouts } = theme;

export default ({ nopad }: PageBodyProps) => ({
  container: {
    ...layouts.column,

    backgroundColor: colors.white,
    alignItems: 'center',
    color: colors.black,
    fontFamily: font.families.primary,

    ...(!nopad && {
      padding: `${scale.s} 0 ${scale.l}`,
    }),
  },
});
